import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IMyDateModel, IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'ngx-datepicker',
  templateUrl: './datepicker.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
  ],
})
export class DatePickerComponent implements ControlValueAccessor {

  @Output() dateSelected: EventEmitter<IMyDateModel> = new EventEmitter();
  @Input() id: string = '';

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: {
      su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab',
    },
    monthLabels: {
      1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Mai', 5: 'Jun',
      7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez',
    },
    firstDayOfWeek: 'su',
  };

  onChange = (value: any) => {
    console.log(value);
  }

  onTouched = () => {
    console.log('touch');
  }

  private innerValue: any = null;

  onDateChanged(event: IMyDateModel): void {
    this.innerValue = event.date;
    this.onChange(this.innerValue);
    this.onTouched();
    this.dateSelected.emit(event);
  }

  writeValue(value: any): void {
    this.innerValue = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
